import { useState } from 'react';
import { connect } from 'react-redux';

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import CustomInputV2 from "../../../common/CustomInputV2";
import CustomModal from '../../../common/CustomModal';
import PromptPropsDetails from './PromptPropsDetails';
import CustomSelect from '../../../common/CustomSelect';
import CustomSelectWeek from '../../../common/CustomSelectWeek';
import CustomSelectAndList from '../../../common/CustomSelectAndList';

function PromptProperties(props) {
    const [initialData, setInitialData] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const handleValueChange = (e, key, index) => {
        props?.setPromptDetails({
            ...props?.promptDetails,
            properties: props?.promptDetails?.properties.map((prop, i) => {
                if (i == index) {
                    return {
                        ...prop,
                        value: e.target.value,
                    }
                }

                return prop;
            }),
        })
    }

    const allPrograms = props?.Program?.all?.list?.map(program => {
        return {
            label: `${program?.title} (${program?.timeline} w/ ${program?.count} workouts )`,
            value: program?.id,
        }
    });


    return (
        <>
            <div id="pd-header">
                <h5>Properties</h5>
                <AddIcon onClick={() => {
                    setInitialData(null);
                    setShowModal(true);
                }} />
            </div>
            <div id="pd-properties">
                {
                    props?.promptDetails?.properties?.map((param, index) => {
                        return (
                            <div className="pd-property">
                                <div>
                                    <div className='pd-p-header'>
                                        <div>
                                            <h6>{param?.name.toUpperCase()} <em> {`{{${param?.key}}}`} </em></h6>
                                            {param?.note && <h6 className='pd-p-note'><em> {`note: ${param?.note}`} </em></h6>}
                                        </div>
                                        <div className="pd-property-actions">
                                            <EditIcon onClick={() => {
                                                setShowModal(true);
                                                setInitialData({
                                                    ...param,
                                                    index: index,
                                                });
                                            }} />
                                            <DeleteIcon onClick={() => {
                                                props?.setPromptDetails({
                                                    ...props?.promptDetails,
                                                    properties: props?.promptDetails?.properties.filter((prop, i) => i != index),
                                                })
                                            }} />
                                        </div>
                                    </div>
                                    {
                                        param?.type == "text" &&
                                        <CustomInputV2
                                            placeholder="Text Value"
                                            value={param?.value}
                                            type="text"
                                            onChange={(e) => {
                                                handleValueChange(e, param?.key, index)
                                            }}
                                            name="name"
                                        />
                                    }

                                    {
                                        param?.type == "date" &&
                                        <CustomInputV2
                                            placeholder="Date Value"
                                            value={param?.value}
                                            type="date"
                                            onChange={(e) => {
                                                handleValueChange(e, param?.key, index)
                                            }}
                                            name="name"
                                        />
                                    }

                                    {
                                        param?.type == "select" &&
                                        <CustomSelect
                                            name="select"
                                            options={[
                                                { label: "", value: "" },
                                                ...param?.options
                                            ]}
                                            value={param?.value}
                                            onChange={(e) => {
                                                handleValueChange(e, param?.key, index)
                                            }}
                                        />
                                    }

                                    {
                                        param?.type == "week" &&
                                        <CustomSelectWeek
                                            value={param?.value}
                                            onChange={(selected) => {
                                                handleValueChange({
                                                    target: {
                                                        value: selected,
                                                    }
                                                }, param?.key, index)
                                            }}
                                        />
                                    }

                                    {
                                        param?.type == "program" &&
                                        <CustomSelectAndList
                                            options={[
                                                { label: "", value: "" },
                                                ...allPrograms
                                            ]}
                                            value={param?.value}
                                            onChange={(selected) => {
                                                handleValueChange({
                                                    target: {
                                                        value: selected,
                                                    }
                                                }, param?.key, index)
                                            }}
                                        />
                                    }

                                </div>
                            </div>
                        )
                    })
                }
            </div>

            <CustomModal
                size="s"
                toggle={setShowModal}
                show={showModal}
                title="Add Props"
                body={(
                    <>
                        <PromptPropsDetails
                            initialData={initialData}
                            addProps={(newProps) => {
                                props?.setPromptDetails({
                                    ...props?.promptDetails,
                                    properties: [
                                        ...props?.promptDetails?.properties,
                                        {
                                            ...newProps,
                                        }
                                    ],
                                });

                                return true;
                            }}

                            updateProps={(updatedProps) => {
                                props?.setPromptDetails({
                                    ...props?.promptDetails,
                                    properties: props?.promptDetails?.properties.map((prop, index) => {
                                        if (index == updatedProps?.index) {
                                            return {
                                                ...updatedProps,
                                            }
                                        }

                                        return prop;
                                    }),
                                })

                                return true;
                            }}

                            exit={() => {
                                setShowModal(false);
                            }}
                        />
                    </>
                )}
            />
        </>
    );
}

const mapStateToProps = (state) => ({
    Program: state.Program,
})

export default connect(mapStateToProps, {
})(PromptProperties);
